import { createContext, useContext } from 'react';

export type SearchContextType = {
    search: string;
};

export const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const useSearchContext = () => {
    const context = useContext(SearchContext);
    if (!context) throw new Error('useSearchContext must be used within a provider');
    return context;
};
